import * as React from "react"
import * as ToggleGroupPrimitive from "@radix-ui/react-toggle-group"

import { cn } from "@/lib/utils"
import { ProductTabIndicator } from "@/components/product-tabs"
import "./index.scss"

function LineToggleGroup({
  className,
  children,
  ...props
}: React.ComponentProps<typeof ToggleGroupPrimitive.Root>) {
  return (
    <ToggleGroupPrimitive.Root
      data-slot="toggle-group"
      className={cn(
        `
                    group/toggle-group flex items-center gap-2
                    overflow-auto
                `,
        className
      )}
      {...props}
    >
      {children}
    </ToggleGroupPrimitive.Root>
  )
}

export interface LineToggleGroupItemProps
  extends React.ComponentProps<typeof ToggleGroupPrimitive.Item> {
  indicator?: ProductTabIndicator
}

function LineToggleGroupItem({
  className,
  children,
  indicator = ProductTabIndicator.None,
  ...props
}: LineToggleGroupItemProps) {
  return (
    <ToggleGroupPrimitive.Item
      data-slot="toggle-group-item"
      className={cn(
        `
          border-input-border text-label-text data-[state=on]:border-blue 
          data-[state=on]:text-blue max-w-max relative
          h-7 flex-1 shrink-0 rounded-full border bg-white px-4 
          py-0.5 text-sm font-medium whitespace-nowrap uppercase shadow-none
          transition-[border,color] hover:cursor-pointer  focus:z-10 focus-visible:z-10
          indicator ${indicator}
        `,
        className
      )}
      {...props}
    >
      {children}
    </ToggleGroupPrimitive.Item>
  )
}

export { LineToggleGroup, LineToggleGroupItem }
